<template>
  <TransitionBase ref="transition" :mode="mode" :appear="appear" :enter="onEnter" :leave="onLeave">
    <slot />
  </TransitionBase>
</template>

<script setup lang="ts">
  import { GsapProvider } from '../../composables/GsapProvider'

  const props = defineProps<{
    mode?: 'out-in' | 'in-out' | undefined // entering element rendered when the leaving element animations is finished
    appear?: boolean | undefined // applies transition on initial render
    enter?: {
      from: {
        x?: number
        y?: number
      }
      delay?: number
      duration?: number
    }
    leave?: {
      to: {
        x?: number
        y?: number
      }
      delay?: number
      duration?: number
    }
  }>()

  const { $gsap } = GsapProvider.use()

  const enterFrom = computed(() => props.enter?.from ?? { x: 100 })
  const leaveTo = computed(() => props.leave?.to ?? { x: 100 })

  const onEnter = (el: any, done: any) => {
    $gsap.from(el, {
      delay: props.enter?.delay ?? 0,
      duration: props.enter?.duration ?? 0.6,
      opacity: 0,
      ...enterFrom.value,
      onComplete: done
    })
  }

  const onLeave = (el: any, done: any) => {
    $gsap.to(el, {
      delay: props.leave?.delay ?? 0,
      duration: props.leave?.duration ?? 0.6,
      opacity: 0,
      ...leaveTo.value,
      onComplete: done
    })
  }

  const transition = ref()
  defineExpose({
    transitioning: computed(() => transition.value?.transitioning)
  })
</script>

<style scoped></style>
